import type { ClientTheme } from "@/api/client.service";
import { Palette } from "@mui/icons-material";
import { Box, Divider, Paper, Stack, Typography } from "@mui/material";
import { COLOR_KEYS } from "../config/ThemeConfigPage";
import { ColorField } from "../ColorField";

const RenderColorSection = ({
  mode,
  title,
  themeConfig,
  handleChange,
  ColorLabels,
}: {
  mode: string;
  title: string;
  themeConfig: Partial<ClientTheme>[];
  handleChange: (mode: string, key: keyof ClientTheme, value: string) => void;
  ColorLabels: Record<string, string>;
}) => {
  const currentTheme = themeConfig.find((t) => t.theme === mode);
  if (!currentTheme) return null;

  return (
    <Paper elevation={3} sx={{ p: 3, borderRadius: 2, mb: 3 }}>
      <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Palette color={mode === 'light' ? 'primary' : 'secondary'} />
        Tema {title}
      </Typography>
      <Divider sx={{ mb: 3 }} />
      <Stack spacing={3}>
        {COLOR_KEYS.map((key) => {
          const colorValue = currentTheme[key] || '#000000';
          return (
            <Box key={key} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <ColorField
                label={`Cor ${ColorLabels[key]}`}
                variant="outlined"
                size="small"
                fullWidth
                value={colorValue}
                onChange={(cor) => handleChange(mode, key, cor)}
              />
            </Box>
          );
        })}
      </Stack>
    </Paper>
  );
};

export default RenderColorSection